import React, { PureComponent } from "react";
import PageLink from "../../../components/Page/PageLink";
import Footer from "../../../components/Footer/Footer";

class PDF_overview extends PureComponent {
  render() {
    return (
      <div className="row" id="pdf_overview">
        <div className="col-md-6 ">
          <div className="contentLight">
            <section>
              <h2>PDF Overview</h2>
              <p>
                The Nexoid library includes a PDF engine. The PDF engine
                converts either HTML or a URL to PDF. Because of the nature or
                rather the potential size of a PDF; Nexoid creates and saves
                these PDF in regionalised AWS S3 buckets. These PDF buckets
                automatically delete the PDF file after 24 hours.
              </p>
              <Footer
                section={this.props.section}
                article={this.props.article}
                routeParams={this.props.routeParams}
              />
            </section>
          </div>
        </div>
        <div className="hidden-sm-xs col-md-6 darkCol ">
          <div className="contentDark"></div>
        </div>
      </div>
    );
  }
}

export default PDF_overview;



// WEBPACK FOOTER //
// ./src/components/knowlege/api/PDF_overview.js